import React from "react";

const Empty = (props) => {
	return (
		<React.Fragment>
			<p>Não tem produtos no carrinho de compras</p>
		</React.Fragment>
	);
};

export default Empty;
